import { UserSummeryAttendance } from '../../../../api/types/programs/course/course-details.type';
import dateUtils from '../../../../utils/date-format';
import generateAndDownloadExcelFile from '../../../../component/excel/generate-and-download-excel-file';
import globalCourseStore from '../../../../stores/global-course-store';

const calculateRelationAttendanceInCourse = (
  occurredAttendance: number,
  occurredLecture: number,
) => {
  const lecturesLength =
    globalCourseStore.getCurrentCourse()?.details?.lectures.length;

  const attendedNumber: number = occurredLecture * occurredAttendance;
  return lecturesLength > 0
    ? `${(attendedNumber / lecturesLength).toFixed(1)}%`
    : '0';
};

export const handleExportCourseStudentsToExcel = (
  studentsData: UserSummeryAttendance[],
) => {
  const fileName = 'סטודנטים בקורס';

  // Create header row
  const headers = [
    'שם',
    'ת.ז',
    'טלפון',
    'תאריך לידה',
    'מייל',
    'סטטוס',
    'אחוז נוכחות יחסי',
    'אחוז נוכחות מוחלט',
    'ציון סופי',
  ];

  // Create data rows
  const dataRows = studentsData.map((student) => {
    const relativeAttendance =
      student.attendancePercentage !== null &&
      student.attendancePercentage !== undefined
        ? `${student.attendancePercentage.toFixed(1)}%`
        : 'טרם הוזנו נתונים';

    const absoluteAttendance =
      student.attendancePercentage !== null &&
      student.attendancePercentage !== undefined &&
      student.courseTotalRequiredLectures !== null &&
      student.courseTotalRequiredLectures !== undefined
        ? calculateRelationAttendanceInCourse(
            student.attendancePercentage,
            student.courseTotalRequiredLectures,
          )
        : 'טרם הוזנו נתונים';

    return [
      `${student.firstName} ${student.lastName}`,
      student.nationalId || '',
      student.phoneNumber || '',
      student.dateOfBirth
        ? dateUtils.displayFormatDate(student.dateOfBirth)
        : 'לא קיים',
      student.email || '',
      student.settingsCourseStatusName || '',
      relativeAttendance,
      absoluteAttendance,
      student.finalGrade?.toString() || '',
    ];
  });

  // Combine headers and data
  const excelData = [headers, ...dataRows];

  // Generate and download
  generateAndDownloadExcelFile(excelData);
};
